import { render, staticRenderFns } from "./UnsubscribeModal.vue?vue&type=template&id=79cc390d&"
import script from "./UnsubscribeModal.vue?vue&type=script&lang=js&"
export * from "./UnsubscribeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports